import { AnimatePresence, motion } from "framer-motion";
import styled from "styled-components";
import { fill } from "../styles/utils";
import { CursorPosition } from "./CursorPosition";

interface CursorHolderProps {
  visible?: boolean;
}

const Holder = styled(motion.div)`
  ${fill("fixed")}
  z-index: 20000;
  pointer-events: none;
`;

export const CursorHolder: React.FC<CursorHolderProps> = ({
  children,
  visible,
}) => {
  return (
    <>
      <Holder
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.1 } }}
        exit={{ opacity: 0 }}
      >
        <CursorPosition visible={visible}>{children}</CursorPosition>
      </Holder>
    </>
  );
};
